import type { Data } from '@strapi/types';
import Cookies from 'js-cookie';

/**
 * Opens new tab with given parameters
 * @param url - url of application
 * @param documentId - project document id in strapi
 * @param toolUrl - name of the tool
 * @param language - language of the application set by user
 */

type GenerateRedirectUrl = {
  url: string;
  documentId: string;
  toolUrl: string;
  user: string;
  region?: Data.Entity<'api::project-document.project-document'>['region'];
  accessLevel?: Data.Entity<'api::document-access.document-access'>['accessLevel'];
};

export const generateRedirectUrl = ({ url, documentId, toolUrl, user, region, accessLevel }: GenerateRedirectUrl) => {
  const computedUrl = new URL(url);
  const params = new URLSearchParams();
  const language = Cookies.get('NEXT_LOCALE');

  if (region?.toLocaleLowerCase() === 'ul') params.append('ul', 'true');
  if (accessLevel) {
    accessLevel === 'edit' ? params.append('edit', 'true') : params.append('edit', 'false');
  }

  params.append('projectId', documentId);
  params.append('toolUrl', toolUrl);
  params.append('language', language ?? 'en');
  params.append('user', user);
  computedUrl.search = params.toString();

  window.open(computedUrl.toString(), '_blank');
};
